import { render, staticRenderFns } from "./loginShe.vue?vue&type=template&id=96b0586e&scoped=true&"
import script from "./loginShe.vue?vue&type=script&lang=js&"
export * from "./loginShe.vue?vue&type=script&lang=js&"
import style0 from "./loginShe.vue?vue&type=style&index=0&id=96b0586e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b0586e",
  null
  
)

export default component.exports